export function mergeClassNames(...classNames: readonly (string | false | null | undefined)[]) {
  return classNames.filter(Boolean).join(' ')
}
